<template>
  <b-container>
    <b-row>
      <b-col cols="6">
        <h1>Color Palette</h1>
        <div class="d-flex">
          <checkbox-button
            v-model="checkboxButton"
            class="mr-2"
            @click.native="changeButton"
          />
          <checkbox-button v-model="checkboxButtonDisabled" />
        </div>
      </b-col>
      <b-col cols="6">
        <h1>Header 1</h1>
        <h2>Header 2</h2>
        <h3>Header 3</h3>
        <h4>Header 4</h4>
        <h5>Header 5</h5>
        <h6>Header 6</h6>
        <p class="h7">Header 7</p>
        <p>Body</p>
        <p class="helper-text">Helper text</p>
        <b-link href="#">Link</b-link>
      </b-col>
      <b-col cols="12">
        <b-form-file
          v-model="file"
          accept="image/jpeg, image/png, image/jpg"
          :state="Boolean(file)"
          placeholder="Choose an image file or drop it here...."
          drop-placeholder="Drop file here..."
        />
        <p class="helper-text">Must be under 2MB and .png, .jpg, or .jpeg</p>
        <b-form-file v-model="file2" class="mt-3" plain></b-form-file>
      </b-col>
      <b-col class="mt-5">
        <b-button variant="primary">Button</b-button>
        <b-button variant="secondary">Button</b-button>
        <button variant="success">Button</button>
        <b-button variant="primary" disabled>Button</b-button>
      </b-col>
      <b-col>
        <p class="success-text">Success messages look like this.</p>
        <p class="error-text">Error messages look like this.</p>
      </b-col>
      <b-col cols="12">
        <div class="base-form">
          <b-form-group label="Input Field Title">
            <b-form-input v-model="textField" placeholder="123" />
          </b-form-group>
          <b-form-textarea v-model="textField" />
          <custom-search-field
            v-model="testSearch"
            class="mt-3"
            :placeholder="'Filter by network'"
            :path-to-search="'networks'"
            :label-field="'name'"
            :statuses="'active'"
          />
        </div>
      </b-col>
      <b-col cols="3">
        <b-form-input
          v-model="textField"
          class="single-input mt-3"
          placeholder="123"
        />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import CheckboxButton from '../../components/CheckboxButton.vue';

export default {
  name: 'Test',
  components: { CheckboxButton },
  data() {
    return {
      file: null,
      file2: null,
      textField: null,
      textArea: null,
      testSearch: null,
      checkboxButton: false,
      checkboxButtonDisabled: null,
    };
  },
  methods: {
    changeButton() {
      console.log('123');
      this.checkboxButton = !this.checkboxButton;
    },
  },
};
</script>
